module.exports = __webpack_public_path__ + "static/media/download.bed73a02.svg";